import { ref } from 'vue';

const DEFAULT_DURATION = 2500;

export const successBannerMessage = ref('');
export const successBannerVisible = ref(false);

let bannerTimer: ReturnType<typeof setTimeout> | null = null;

export function showWebAppSuccessBanner(message: string, duration = DEFAULT_DURATION) {
  successBannerMessage.value = message;
  successBannerVisible.value = true;

  if (bannerTimer) clearTimeout(bannerTimer);

  bannerTimer = setTimeout(() => {
    successBannerVisible.value = false;
  }, duration);
}

export function useWebAppSuccessBanner() {
  return {
    successBannerMessage,
    successBannerVisible,
    showWebAppSuccessBanner,
  };
}
